import { createMessageName } from '@formkit/validation';
import { sentence, date, order, list } from '../formatters.mjs';

// packages/i18n/src/locales/en.ts
var add = "Add";
var remove = "Remove";
var removeAll = "Remove all";
var incomplete = "Sorry, not all fields are filled out correctly.";
var submit = "Submit";
var noFiles = "No file chosen";
var moveUp = "Move up";
var moveDown = "Move down";
var isLoading = "Loading...";
var loadMore = "Load more";
var next = "Next";
var prev = "Previous";
var addAllValues = "Add all values";
var addSelectedValues = "Add selected values";
var removeAllValues = "Remove all values";
var removeSelectedValues = "Remove selected values";
var chooseDate = "Choose date";
var changeDate = "Change date";
var summaryHeader = "There were errors in your form.";
var close = "Close";
var open = "Open";
var accepted = function({
  name
}) {
  return `Please accept the ${name}.`;
};
var date_after = function({
  name,
  args
}) {
  if (Array.isArray(args) && args.length) {
    return `${sentence(name)} must be after ${date(args[0])}.`;
  }
  return `${sentence(name)} must be in the future.`;
};
var alpha = function({
  name
}) {
  return `${sentence(name)} can only contain alphabetical characters.`;
};
var alphanumeric = function({
  name
}) {
  return `${sentence(name)} can only contain letters and numbers.`;
};
var alpha_spaces = function({
  name
}) {
  return `${sentence(name)} can only contain letters and spaces.`;
};
var contains_alpha = function({
  name
}) {
  return `${sentence(name)} must contain alphabetical characters.`;
};
var contains_alphanumeric = function({
  name
}) {
  return `${sentence(name)} must contain letters or numbers.`;
};
var contains_alpha_spaces = function({
  name
}) {
  return `${sentence(name)} must contain letters or spaces.`;
};
var contains_symbol = function({
  name
}) {
  return `${sentence(name)} must contain a symbol.`;
};
var contains_uppercase = function({
  name
}) {
  return `${sentence(name)} must contain an uppercase letter.`;
};
var contains_lowercase = function({
  name
}) {
  return `${sentence(name)} must contain a lowercase letter.`;
};
var contains_numeric = function({
  name
}) {
  return `${sentence(name)} must contain numbers.`;
};
var symbol = function({
  name
}) {
  return `${sentence(name)} must be a symbol.`;
};
var uppercase = function({
  name
}) {
  return `${sentence(name)} can only contain uppercase letters.`;
};
var lowercase = function({
  name,
  args
}) {
  let postfix = "";
  if (Array.isArray(args) && args.length) {
    if (args[0] === "allow_non_alpha")
      postfix = ", numbers and symbols";
    if (args[0] === "allow_numeric")
      postfix = " and numbers";
    if (args[0] === "allow_numeric_dashes")
      postfix = ", numbers and dashes";
  }
  return `${sentence(name)} can only contain lowercase letters${postfix}.`;
};
var date_before = function({
  name,
  args
}) {
  if (Array.isArray(args) && args.length) {
    return `${sentence(name)} must be before ${date(args[0])}.`;
  }
  return `${sentence(name)} must be in the past.`;
};
var between = function({
  name,
  args
}) {
  if (isNaN(args[0]) || isNaN(args[1])) {
    return `This field was configured incorrectly and can’t be submitted.`;
  }
  const [a, b] = order(args[0], args[1]);
  return `${sentence(name)} must be between ${a} and ${b}.`;
};
var confirm = function({
  name
}) {
  return `${sentence(name)} does not match.`;
};
var date_format = function({
  name,
  args
}) {
  if (Array.isArray(args) && args.length) {
    return `${sentence(name)} is not a valid date, please use the format ${args[0]}`;
  }
  return "This field was configured incorrectly and can’t be submitted";
};
var date_between = function({
  name,
  args
}) {
  return `${sentence(name)} must be between ${date(args[0])} and ${date(args[1])}`;
};
var email = "Please enter a valid email address.";
var ends_with = function({
  name,
  args
}) {
  return `${sentence(name)} doesn’t end with ${list(args)}.`;
};
var is = function({
  name
}) {
  return `${sentence(name)} is not an allowed value.`;
};
var length = function({
  name,
  args: [first = 0, second = Infinity]
}) {
  const min2 = Number(first) <= Number(second) ? first : second;
  const max2 = Number(second) >= Number(first) ? second : first;
  if (min2 == 1 && max2 === Infinity) {
    return `${sentence(name)} must be at least one character.`;
  }
  if (min2 == 0 && max2) {
    return `${sentence(name)} must be less than or equal to ${max2} characters.`;
  }
  if (min2 === max2) {
    return `${sentence(name)} should be ${max2} characters long.`;
  }
  if (min2 && max2 === Infinity) {
    return `${sentence(name)} must be greater than or equal to ${min2} characters.`;
  }
  return `${sentence(name)} must be between ${min2} and ${max2} characters.`;
};
var matches = function({
  name
}) {
  return `${sentence(name)} is not an allowed value.`;
};
var max = function({
  name,
  node: {
    value
  },
  args
}) {
  if (Array.isArray(value)) {
    return `Cannot have more than ${args[0]} ${name}.`;
  }
  return `${sentence(name)} must be no more than ${args[0]}.`;
};
var mime = function({
  name,
  args
}) {
  if (!args[0]) {
    return "No file formats allowed.";
  }
  return `${sentence(name)} must be of the type: ${args[0]}`;
};
var min = function({
  name,
  node: {
    value
  },
  args
}) {
  if (Array.isArray(value)) {
    return `Cannot have fewer than ${args[0]} ${name}.`;
  }
  return `${sentence(name)} must be at least ${args[0]}.`;
};
var not = function({
  name,
  node: {
    value
  }
}) {
  return `“${value}” is not an allowed ${name}.`;
};
var number = function({
  name
}) {
  return `${sentence(name)} must be a number.`;
};
var require_one = function({
  name,
  node,
  args: inputNames
}) {
  const labels = inputNames.map((name2) => {
    const dependentNode = node.at(name2);
    if (dependentNode) {
      return createMessageName(dependentNode);
    }
    return false;
  }).filter((name2) => !!name2);
  labels.unshift(name);
  return `${labels.join(" or ")} is required.`;
};
var required = function({
  name
}) {
  return `${sentence(name)} is required.`;
};
var starts_with = function({
  name,
  args
}) {
  return `${sentence(name)} doesn’t start with ${list(args)}.`;
};
var url = function() {
  return `Please enter a valid URL.`;
};
var invalidDate = "The selected date is invalid.";
var ui = {
  add,
  remove,
  removeAll,
  incomplete,
  submit,
  noFiles,
  moveUp,
  moveDown,
  isLoading,
  loadMore,
  next,
  prev,
  addAllValues,
  addSelectedValues,
  removeAllValues,
  removeSelectedValues,
  chooseDate,
  changeDate,
  summaryHeader,
  close,
  open
};
var validation = {
  accepted,
  date_after,
  alpha,
  alphanumeric,
  alpha_spaces,
  contains_alpha,
  contains_alphanumeric,
  contains_alpha_spaces,
  contains_symbol,
  contains_uppercase,
  contains_lowercase,
  contains_numeric,
  symbol,
  uppercase,
  lowercase,
  date_before,
  between,
  confirm,
  date_format,
  date_between,
  email,
  ends_with,
  is,
  length,
  matches,
  max,
  mime,
  min,
  not,
  number,
  require_one,
  required,
  starts_with,
  url,
  invalidDate
};
var en_default = {
  ui,
  validation
};

export { accepted, add, addAllValues, addSelectedValues, alpha, alpha_spaces, alphanumeric, between, changeDate, chooseDate, close, confirm, contains_alpha, contains_alpha_spaces, contains_alphanumeric, contains_lowercase, contains_numeric, contains_symbol, contains_uppercase, date_after, date_before, date_between, date_format, en_default as default, email, ends_with, incomplete, invalidDate, is, isLoading, length, loadMore, lowercase, matches, max, mime, min, moveDown, moveUp, next, noFiles, not, number, open, prev, remove, removeAll, removeAllValues, removeSelectedValues, require_one, required, starts_with, submit, summaryHeader, symbol, uppercase, url };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=en.mjs.map